import * as actions from './actions';

export default (state = {}, action) => {
  switch (action.type) {
    case actions.INIT.BEGIN:
      return {
        ...state,
        projectId: action.projectId,
      };
    case actions.INIT.END:
      return {
        ...state,
        tags: action.tags,
        tagOptions: action.tagOptions,
        changes: 0,
        errors: null,
      };
    case actions.SAVE.END:
      return {
        ...state,
        tags: action.tags,
      };
    case actions.INVALIDATE:
      return {
        ...state,
        tagOptions: action.tagOptions,
        changes: action.changes,
      };
    case actions.RESET_CHANGES.END:
      return {
        ...state,
        tagOptions: action.tagOptions,
        changes: 0,
        errors: null,
      };
    case actions.SET_NAME.END:
    case actions.SET_REMOVED.END:
    case actions.ADD.END:
    case actions.REMOVE.END:
      return {
        ...state,
        tagOptions: action.tagOptions,
      };
    case actions.CHECK_VALIDATION.END:
      return {
        ...state,
        errors: action.errors,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ../redux/store/configuration/project/editor/tag/reducer.js